/**
 * The outcome a task reports, as a word: `ok`, `failed`, or `none` for a
 * task that has no boolean `success` yet. A completed task can still have
 * failed at what it was asked to do, which is why this sits beside the
 * status rather than inside it.
 */
import type { TaskOutcome } from '@optum/api-client/types';

export const OUTCOME_WORD: Record<TaskOutcome, { label: string; color: string }> = {
  true: { label: 'ok', color: 'var(--ok)' },
  false: { label: 'failed', color: 'var(--danger)' },
  none: { label: 'none', color: 'var(--text-faint)' },
};

export function outcomeOf(success: boolean | null): TaskOutcome {
  if (success === null) return 'none';
  return success ? 'true' : 'false';
}

export function OutcomeWord({ success }: { success: boolean | null }) {
  const word = OUTCOME_WORD[outcomeOf(success)];
  return (
    <span
      title="outcome"
      className="mono"
      style={{
        fontSize: 'var(--text-meta-lg)',
        fontWeight: 'var(--weight-semibold)',
        color: word.color,
      }}
    >
      {word.label}
    </span>
  );
}
